<template>
    <div v-if="showInfoModal">
        <b-modal v-model="showInfoModal"
                 :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="onClose"></span>
            </template>

            <div class="confettiModal">
                <img src="@/assets/icons/confetti.svg">
            </div>
            <div class="place">
                <div class="place_img">
                    <img :src="settings.place_info.place.preview" alt="place img"
                         v-if="settings.place_info.place.preview.length != 0">
                    <img v-else src="@/assets/re/default_place_img.jpg" alt="place img">
                </div>
                <div class="place_name">{{settings.place_info.place.name}}</div>
            </div>

            <div>
                <div class="giveaway__wrapper" v-if="!giveaway.participates && !redirectToSocialMode">
                    <div class="giveaway__title">{{translate('giveawayPopup_title')}}</div>
                    <div class="giveaway-checkList">
                        <div class="checkList__wrapper">
                            <div class="checkList__content">
                                <div class="content__number" v-if="accessToken">
                                    <img src="@/assets/icons/ic_success.svg">
                                </div>
                                <div v-else class="content__number">
                                    1
                                </div>
                                <div class="content__text">{{translate('giveawayPopup_login')}}</div>
                            </div>
                            <div class="checkList__content">
                                <div class="content__number">
                                    2
                                </div>
                                <div class="content__text">{{translate('giveawayPopup_review',
                                    [settings.place_info.place.name])}}
                                </div>
                            </div>
                            <div class="checkList__content">
                                <div class="content__number">
                                    3
                                </div>
                                <div class="content__text">{{translate('giveawayPopup_entered')}} {{giveaway.giveaway_title}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="giveaway-login">
                        <div class="login__wrapper" v-if="!accessToken">
                            <div class="login__title">{{translate('giveawayPopup_BtnLogin')}}</div>
                            <div class="loginBtn">
                                <div class="loginBtnFacebook__wrapper" @click="onFacebookSignIn">
                                    <div class="loginBtn__icon">
                                        <img src="@/assets/icons/ic_facebook_logo.svg">
                                    </div>
                                    <div class="loginBtn__text">Facebook</div>
                                </div>
                                <div class="loginBtnGoogle__wrapper" @click="onGoogleSingIn">
                                    <div class="loginBtn__icon">
                                        <img src="@/assets/icons/ic_google_logo.svg">
                                    </div>
                                    <div class="loginBtn__text">Google</div>
                                </div>
                                <v-facebook-login @sdk-init="sdkLoaded" app-id="770275700057951"
                                                  hidden></v-facebook-login>
                            </div>
                        </div>
                        <div class="login__wrapper" v-else>
                            <div class="login__title">{{translate('giveawayPopup_BtnReview')}}</div>
                            <div class="reviewBtn">
                                <div :class="link.network.alias + '-button'"
                                     :key="index"
                                     @click="openSocialLink(link)"
                                     class="review-btn"
                                     v-for="(link, index) in settings.place_info.place.links">
                                    <div class="reviewBtn__icon">
                                        <img alt="" src="../../assets/icons/ic_facebook_logo.svg"
                                             v-if="link.network.id == 1">
                                        <img alt="" src="../../assets/icons/yelp-light.svg" v-if="link.network.id == 2">
                                        <img alt="" src="../../assets/icons/ic_google_logo.svg"
                                             v-if="link.network.id == 3">
                                        <img alt="" src="../../assets/icons/tripadvisor-light.svg"
                                             v-if="link.network.id == 4">
                                        <img alt="" src="../../assets/icons/ic_vk_light.svg"
                                             v-if="link.network.id == 6">
                                        <img alt="" src="../../assets/icons/ic_instagram_light.svg"
                                             v-if="link.network.id == 5">
                                        <img alt="" src="../../assets/icons/ic_web_light.svg"
                                             v-if="link.network.id == 7">
                                        <img alt="" src="@/assets/icons/ic_donate_light.svg"
                                             v-if="link.network.alias == 'donate'">
                                        <img alt="" src="@/assets/images/ic_adopt_light.png"
                                             v-if="link.network.alias == 'adopt'" style="width: 22px; height: 22px;">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="giveaway-cancel">
                        <div class="cancel__wrapper" @click="onClose">
                            <div class="cancel__text">{{translate('giveawayPopup_cancel')}}</div>
                        </div>
                    </div>
                </div>
                <div v-else-if="!redirectToSocialMode">
                    <div class="giveaway__title">{{translate('giveawayBottomFinish_title')}}</div>
                    <div class="finalStep">
                        <div class="finalStep__text">
                            {{this.giveaway.description}}
                        </div>
                    </div>
                    <div class="closeBtn" @click="onClose">
                        <div class="closeBtn__text">
                            {{translate('Close')}}
                        </div>
                    </div>
                </div>
                <div v-else-if="redirectToSocialMode">
                    <div class="giveaway__title">{{translate('giveawayBottomFinish_title')}}</div>
                    <div class="finalStep">
                        <div class="finalStep__text">
                            {{translate('giveawayPopup_finalStep')}}
                        </div>
                    </div>
                    <div @click="confirmRedirectToSocial" class="closeBtn">
                        <div class="closeBtn__text">
                            {{translate('giveawayPopup_proceedReview')}}
                        </div>
                    </div>
                </div>
            </div>

            <template v-slot:modal-footer>
                <b-button v-if="settings.showCancelButton" variant="default" class="secondary" @click="onClose">
                    <template v-if="settings.cancelButtonText">{{ settings.cancelButtonText }}</template>
                    <template v-else>{{ translate('Cancel') }}</template>
                </b-button>

                <b-button v-if="settings.showAdditionalButton" variant="success" class="btn-primary"
                          @click="onAdditional">
                    <template v-if="settings.additionalButtonText">{{ settings.additionalButtonText }}</template>
                    <template v-else>Additional</template>
                </b-button>

                <b-button v-if="!settings.hideOkButton" class="btn-primary" variant="primary" @click="onOk">
                    <template v-if="settings.okButtonText">{{ settings.okButtonText }}</template>
                    <template v-else>{{translate('OK')}}</template>
                </b-button>

            </template>
        </b-modal>

    </div>
</template>

<script>
    import _ from "lodash";
    import errorMixin from '@/mixins/errorMixin';
    import rateMixin from '@/mixins/rateMixin';
    import {mapActions, mapGetters, mapState} from "vuex";
    import logAnalyticsEvent from '@/helpers/analytics'
    import {VFBLogin as VFacebookLogin} from 'vue-facebook-login-component'

    export default {
        name: "giveawayModal",

        mixins: [mixin, errorMixin, rateMixin],

        data() {
            return {
                showInfoModal: !_.isEmpty(this.settings),
                place_img: '',
                redirectToSocialMode: null
            }
        },
        components: {
            VFacebookLogin,
        },

        watch: {
            settings(newValue) {
                this.showInfoModal = !_.isEmpty(newValue)
            }
        },

        props: {
            settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
        async mounted() {

        },
        computed: {
            ...mapGetters({
                isUserClient: 'auth/isUserClient',
                isUserOwner: 'auth/isUserOwner',
                isUserAdmin: 'auth/isUserAdmin',
                getOwnPlace: 'auth/getOwnPlace',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
                getFormatedLang: 'getFormatedLang',
                giveaway: 'rate/getGiveaway',
            }),
            ...mapState({
                accessToken: state => state.auth.accessToken,
                anonymousToken: state => state.auth.anonymousToken,
                voted: state => state.voted,
                userInfo: state => state.auth.userInfo
            })
        },


        methods: {
            ...mapActions({
                logIn: 'auth/logIn',
                fetchUserInfo: 'auth/fetchUserInfo',
                getRateInfoAction: 'rate/getRateInfo',
            }),

            getIconStyle() {
                if (this.settings.icon) {
                    return {
                        backgroundImage: 'url(' + require(`@/assets/icons/${this.settings.icon}`) + ')'
                    }
                } else {
                    return null
                }
            },

            async onClose() {
                this.showInfoModal = false
                if (this.settings.onCancelHandler) {
                    try {
                        await this.settings.onCancelHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            async onOk() {
                this.showInfoModal = false
                if (this.settings.onOkHandler) {
                    try {
                        await this.settings.onOkHandler(this.settings)
                    } catch (error) {
                        this.showErrorModal(error.message)
                    }
                }
            },

            onAdditional() {
                this.showInfoModal = false
                if (this.settings.onAdditionalHandler) {
                    this.settings.onAdditionalHandler(this.settings)
                }
            },
            async onGoogleSingIn() {
                await this.GoogleSignIn({
                    becomeOwner: false,
                    redirect: false
                })
                await this.handleUserFlow()
            },

            async onFacebookSignIn() {
                await this.FacebookSignIn({
                    becomeOwner: false,
                    redirect: false
                })
                await this.handleUserFlow()
            },

            openSocialLink(link) {
                logAnalyticsEvent('giveaway_soc_review_item_click')
                this.redirectToSocialMode = {
                    link: link
                }
            },

            confirmRedirectToSocial() {
                let link = this.redirectToSocialMode.link
                this.redirectToSocialMode = null
                let result = this.sendSocialClickToServer(this.settings.currentVoteUid, link.uid)
                if (result) {
                    this.$store.commit('rate/setGiveawayParticipates', true)
                }
                window.open(link.url, '_blank');
            },

            async handleUserFlow() {
                try {
                    await this.fetchUserInfo()
                    const response = await this.getRateInfoAction(this.settings.question_id)
                    this.$store.commit('rate/setGiveawayParticipates', response.data.giveaway.user_started)
                } catch (error) {
                    this.showErrorModal(error.data.error.message)
                }
            },

        },
    }
</script>

<style scoped>
    .modal-secondary-text {
        font-size: 12px;
        font-weight: 700;
        margin-top: 15px;
    }

    .custom-modal.leftAlign .modal-input {
        text-align: left;
    }


    .custom-modal .close-icon {
        position: static;
        cursor: pointer;
        width: 28px;
        height: 28px;
        display: none;
        background: url('../../assets/icons/ic_close_white.svg') 50% no-repeat;
    }

    .confettiModal {
        position: absolute;
        top: -120px;
        left: 0;
    }
    .confettiModal img {
        width: 650px;
    }
    .place {
        position: relative;
    }
    .place_name {
        position: relative;
    }
    .custom-modal .modal-title {
        font-size: 18px;
        font-weight: bold;
        color: #2F2F2F;
        text-align: center;
    }

    .custom-modal .modal-header {
        text-align: center;
        border: none;
        justify-content: flex-end;
        padding-bottom: 0;
    }

    .custom-modal.welcome-modal .modal-footer {
        flex-direction: column;
    }

    .custom-modal.welcome-modal .modal-footer > * {
        width: 100%;
        margin: 5px 0;
        text-decoration: none;
    }

    .custom-modal .modal-footer a {
        text-decoration: none;
    }

    .custom-modal .modal-footer {
        border: none;
    }

    .custom-modal .modal-message {
        font-size: 16px;
        color: #2F2F2F;
        max-width: 360px;
        margin: 15px auto 0;
    }

    .custom-modal {
        text-align: center;
    }

    .modal-input {
        margin-top: 15px;
    }

    .modal-input input:focus {
        border-color: #2F2F2F;
        box-shadow: 0 0 0 0.2rem rgba(47, 47, 47, 0.25);
    }

    .custom-modal .btn {
        min-width: 140px;
        padding: 10px 12px;
        border-radius: 0;
        border: none;
        font-size: 14px;
        font-weight: bold;
        width: 100%;
    }


    .custom-modal .btn:not(:disabled):not(.disabled):active,
    .custom-modal .btn:active,
    .custom-modal .btn:active:focus,
    .custom-modal .btn:focus {
        border-radius: 6px;
        box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.24);
    }

    .custom-modal .modal-icon {
        width: 56px;
        height: 56px;
        margin: 0 auto;
        background-size: cover;
        margin-bottom: 15px;
    }

    .custom-modal .btn.btn-primary {
        background: #2F2F2F;
        color: #ffffff;
    }

    /**/
    .full-width--btn.large {
        min-width: 40vw;
        font-size: 0.7vw;
        transform: translateX(-50%);
        left: 50%;
    }

    .full-width--btn.large.custom-modal .modal-message {
        width: 90%;
    }

    .full-width--btn.custom-modal .btn {
        width: 100%;
    }

    .giveaway__title {
        color: #3F405C;
        font-family: Montserrat;
        font-size: 24px;
        font-weight: 900;
        letter-spacing: 2px;
        line-height: 28px;
        text-align: center;
        margin-top: 25px;
        position: relative;
    }

    .checkList__wrapper {
        margin-top: 40px;
    }

    .checkList__content {
        display: flex;
        justify-content: center;
        margin-bottom: 25px;
        align-items: center;
    }

    .content__number {
        color: #3F405C;
        font-family: Montserrat;
        font-size: 18px;
        font-weight: 900;
        letter-spacing: 1.69px;
        margin-left: -10px;
        margin-right: 15px;
        width: 24px;
    }

    .content__text {
        color: #2F2F2F;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 22px;
        margin-left: 35px;
        width: 280px;
        text-align: start;
    }

    .login__wrapper {
        border-radius: 8px;
        background-color: #3F405C;
        width: 100%;
    }

    .loginBtn {
        display: flex;
        justify-content: space-around;
        padding: 24px 15px 16px 16px;

    }

    .login__title {
        padding-top: 20px;
        text-align: center;
        color: #FFFFFF;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 22px;
    }

    .loginBtnFacebook__wrapper {
        display: flex;
        align-items: center;
        border-radius: 4px;
        background-color: #1976D2;
        padding: 12px 23px;
    }
    .loginBtnFacebook__wrapper:hover {
        cursor: pointer;
    }

    .loginBtnGoogle__wrapper {
        display: flex;
        align-items: center;
        border-radius: 4px;
        background-color: #DD4B39;
        padding: 12px 32px;
    }
    .loginBtnGoogle__wrapper:hover {
        cursor: pointer;
    }

    .loginBtn__icon {
        padding-right: 4px;
    }

    .loginBtn__text {
        color: #FFFFFF;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 24px;
    }

    .cancel__wrapper {
        padding-top: 27px;
    }
    .cancel__wrapper:hover {
        cursor: pointer;
    }

    .cancel__text {
        color: #2F2F2F;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 18px;
    }

    .reviewBtn {
        display: flex;
        justify-content: space-around;
        padding: 17px 15px 16px 16px;
    }

    .login__wrapper .review-btn {
        border-radius: 4px;
        padding: 12px 12px;
    }

    .login__wrapper .review-btn:hover {
        cursor: pointer;
    }

    .login__wrapper .review-btn.facebook-button {
        background-color: #1976D2;
    }

    .login__wrapper .review-btn.yelp-button {
        background-color: #FE5022;
    }

    .login__wrapper .review-btn.google-button {
        background-color: #DD4B39;
    }

    .login__wrapper .review-btn.tripadvisor-button {
        background-color: #DD4B39;
    }

    .login__wrapper .review-btn.instagram-button {
        background-color: #DD4B39;
    }

    .login__wrapper .review-btn.vk-button {
        background-color: #DD4B39;
    }

    .login__wrapper .review-btn.website-button {
        background-color: #DD4B39;
    }

    .custom-modal.social-modal .primaryButton.donate-button {
        background: #00a99e;
    }

    .custom-modal.social-modal .primaryButton.adopt-button {
        background: #9d1c20;
    }

    .place_img {
        width: 48px;
        height: 48px;
        margin: 1em auto 1em;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 0px 0px 0px 6px #fff, 0px 0px 7px 3px #555;
    }

    .place_img img {
        min-width: 48px;
        min-height: 48px;
        margin: 0 auto;
        display: block;
        width: 100%;
        height: 100%;
    }

    .finalStep {
        margin-top: 10px;
    }

    .finalStep__text {
        white-space: pre-line;
        color: #2F2F2F;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 22px;
        text-align: start;
        padding-left: 24px;
        padding-right: 24px;
        position: relative;
    }

    .closeBtn {
        margin-top: 32px;
        border-radius: 4px;
        background-color: #2F2F2F;
        padding: 12px 12px;
        margin-left: 24px;
        margin-right: 24px;
    }

    .closeBtn:hover {
        cursor: pointer;
    }

    .closeBtn__text {
        color: #FFFFFF;
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 24px;
    }


    @media screen and (max-width: 1000px) {
        .full-width--btn.custom-modal .modal-footer button {
            width: 100%;
            margin: 0;
            margin-top: 3vw;
        }

        .full-width--btn.custom-modal .modal-footer {
            border: none;
            flex-direction: column-reverse;
            /* width: 100%; */
        }
    }
    @media screen and (max-width: 769px ) {
        .confettiModal {
            left: 15%;
        }
    }
    @media screen and (max-width: 426px) {
        .confettiModal {
            left: 0px;
            top: -55px;

        }
    }
    @media screen and (max-width: 376px) {
        .loginBtnFacebook__wrapper {
            padding: 12px 15px;
        }
        .loginBtnGoogle__wrapper {
            padding: 12px 25px;
        }
        .content__text {
            margin-left: 15px;
        }
        .closeBtn {
            padding: 12px 12px;
        }
    }
    @media screen and (max-width: 321px) {
        .loginBtnGoogle__wrapper {
            padding: 12px 5px;
        }
        .loginBtnFacebook__wrapper {
            padding: 12px 3px;
        }
    }

    .modalDialogCheckbox {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 10px;

    }
</style>

<style>
    .custom-modal {
        overflow: hidden !important;
    }
</style>